export const AccessRightCodes = {
  Dashboard: "Dashboard",
  SettingsEnterprise: "SettingsEnterprise",
  SettingsAdvisor: "SettingsAdvisor",
  UserManagement: "UserManagement",
  InstanceManagement: "InstanceManagement",
  CodelistManagement: "CodelistManagement",
  CodelistManagementImport: "CodelistManagementImport",
};
